import { makeStyles } from '@mui/styles';
import { AppTheme } from '../../../../theme';

export const useStyles = makeStyles((theme: AppTheme) => ({
  title: {
    marginBottom: theme.spacing(0.5),
  },
  headingWithImageContainer: {
    marginBottom: theme.spacing(1),
  },
  container: {
    margin: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  image: {
    objectFit: 'contain',
  },
  endIcon: {
    marginLeft: 'auto',
  },
  startIcon: {
    marginRight: theme.spacing(2),
  },
  actionText: {
    ...theme.typography.body1,
    color: theme.palette.black.main,
    textTransform: 'none',
  },
  button: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(2),
  },
  link: {
    textDecoration: 'none',
  }
}));
